export const TERMS_AND_CONDITIONS = "terms-and-conditions"
